/**
 * 倒计时组件，用于挂在文本上
 */


const Event = require("cocos/framework/components/event")

let CountDownCmpt = xClass("CountDownCmpt", Event)

const MINTIME = 60
const HOURTIME = MINTIME * 60
const DAYTIME = HOURTIME * 24

const Events = CountDownCmpt.Events = {
    Alert: "COUNTDOWN_CMPT_EVT_ALERT",  // 倒计时到点事件    
}

/**
 * 通用方法，启动一次倒计时组件，并在完成后销毁
 * @param {object} target 组件生效目标，必须实现 setString(value: string)=> void 接口
 * @param {number} timestamp 结束时间戳
 * @param {()=>void} onAlert 倒计时结束回调
 * @param {string|function(remain, day,hour,minute,second)=> string}format 格式化方式
 * @param useLocalTime 是否使用本地时间。为false时使用Localhost.time()服务器校准后时间进行计算。为true时通过new Date()进行计算
 */
CountDownCmpt.AutoRun = function (target, timestamp, onAlert, format, useLocalTime, minTime = 1 / 10) {
    let cmpt = CountDownCmpt.create(target);
    cmpt.once(Events.Alert, function (evt) {
        evt.target.destroy();
        onAlert && onAlert();
    });
    cmpt.start(timestamp, format, useLocalTime, minTime);
    return cmpt;
}

/**
 * 初始化
 * @param {object} target 组件生效目标，必须实现 setString(value: string)=> void 接口
 */
CountDownCmpt.prototype.ctor = function (target) {
    let self = this;

    if (__DEBUG) {
        if (typeof target.setString !== "function") {
            throw new Error("target for CountDownCmpt must implement method: setString!");
        }
    }
    self._target = target;
    self.bind(self);

    self._schedulerId = null;
}

/**
 * 启动倒计时
 * @param {number} timestamp 结束时间戳
 * @param {string|function(remain, day,hour,minute,second)=> string}format 格式化方式
 * @param useLocalTime 是否使用本地时间。为false时使用Localhost.time()服务器校准后时间进行计算。为true时通过new Date()进行计算
 */
CountDownCmpt.prototype.start = function (timestamp, format, useLocalTime, minTime) {
    let self = this;

    clearScheduler(self);

    self._timeStamp = tonumber(timestamp)
    if (isNaN(self._timeStamp))
        self._timeStamp = 0;

    self._format = format || "%2$02d:%3$02d:%4$02d";
    self._useLocalTime = useLocalTime;

    update(self);

    if (self._format) {
        self._schedulerId = cc.director.getScheduler().scheduleScriptFunc(function () { update(self); }, minTime, false);
    }
}

CountDownCmpt.prototype.stop = function () {
    let self = this;
    clearScheduler(self);
    self._timeStamp = null;
    self._format = null;
    self._useLocalTime = null;
}
CountDownCmpt.prototype.destroy = function () {
    let self = this;

    self.stop();
    self._target = null;
    self.removeAllEventListeners();
}



function update(self) {
    if (!self._timeStamp || !self._format || !self._target) {
        self.stop();
        return;
    }

    let now = self._useLocalTime ? new Date().getTime() : Localhost.time();
    let remain = Math.max(0, self._timeStamp - now);
    let sec = Math.floor(remain / 1000);
    let day = Math.floor(sec / DAYTIME);
    sec = sec - day * DAYTIME;
    let hour = Math.floor(sec / HOURTIME);
    sec = sec - hour * HOURTIME;
    let min = Math.floor(sec / MINTIME);
    sec = sec - min * MINTIME;

    if (typeof self._format === "string") {
        self._target.setString(string.format(self._format, day, hour, min, sec));
    } else {
        let str = self._format(remain, day, hour, min, sec);
        if (str === undefined) {
            throw new Error("!!!!")
        }
        self._format && self._target.setString(str);
    }

    // 如果format方法是函数，可能定时器会被停止或销毁，使用self._format是否存在来判断定时器是否还在update
    if (self._format && self._timeStamp - now < 0) {
        self.stop();
        self.dispatchEvent({ name: Events.Alert });
    }
}

function clearScheduler(self) {
    if (self._schedulerId) {
        cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId);
        self._schedulerId = null;
    }
}
module.exports = CountDownCmpt;